export const size = {
  fullscreen: {
    width: '100vw',
    height: '100vh',
  },
};
